import { create } from "zustand";

interface VoiceState {
  isVoiceActive: boolean;
  setVoiceActive: (active: boolean) => void;
}

export const useVoiceStore = create<VoiceState>((set) => ({
  isVoiceActive: false,
  setVoiceActive: (active) => set({ isVoiceActive: active }),
}));

// Non-reactive audio level for per-frame DOM reads (avoids 60fps Zustand updates)
export let currentAudioLevel = 0;
export function setCurrentAudioLevel(level: number) {
  currentAudioLevel = level;
}
